
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { Observable } from 'rxjs';
import { map, startWith, take } from 'rxjs/operators';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-cd003-card-IX',
    templateUrl: './cd003-card-IX.component.html'
})

export class Cd003CardIXComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listAvaliacaoFinal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listAvaliacaoFinalOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listSiloDestino?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listSiloDestinoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    site = localStorage.getItem('data_site') ;

    regex: RegExp = /^[\w]+$/;
    @Output() mkCalc = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Dados Resultantes do Lote', false);
        if (this.isComercial) {
            this.formulario = this.formBuilder.group({
                avaliacao_final: [null, []],
                peso_estimado_kg: [null, [Validators.required, Validators.pattern(this.regex)]],
                silo_destino: [null, []],
                usuario: [null, []],
                observacao: [null, []],
                criado_por: [null, []],
            });
        }
        else {
            this.formulario = this.formBuilder.group({
                avaliacao_final: [null, [Validators.required]],
                //peso_estimado_kg: [null, []],
                silo_destino: [null, [Validators.required]],
                usuario: [null, []],
                observacao: [null, []],
                criado_por: [null, []],
                responsavel_pela_analise: [null, [Validators.required]],
                responsavel_autorizacao_especial: [null, [Validators.required]],
                justificativa_aprovacao_especial: [null,  [Validators.required]]
            });
        }

    }

    public async ngOnInit(): Promise<void> {
        await this.getLists();
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async getLists(): Promise<void> {
        await Promise.all([
            this.getListAvaFinal(),
            this.getListSiloDestino()
        ]);
    }

    async getListAvaFinal(): Promise<void> {
        await this.formularioService.getListDropDownList('cd003', 'avaliacao_final').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listAvaliacaoFinal = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listAvaliacaoFinalOriginal = this.listAvaliacaoFinal;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, 'Erro para buscar do banco de dados para montagem da lista de Avaliação Final');
        });
    }


    async getListSiloDestino(): Promise<void> {
        await this.formularioService.getListDropDownList('cd003', 'silo_destino', this.site).pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listSiloDestino = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listSiloDestinoOriginal = this.listSiloDestino;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSiloOrigem);
        });
    }

    // async getListSiloDestino(): Promise<void> {
    //     await this.formularioService.getListDropDownList('cd003', 'destino').pipe(take(1)).toPromise().then(response => {
    //         if (!!response?.data) {
    //             this.listSiloDestino = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
    //             this.listSiloDestinoOriginal = this.listSiloDestino;
    //         }
    //     }).catch((error: HttpErrorResponse) => {
    //          this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorDestino);
    //     });
    // }

    createFilterAvaliacaoFinal(value?: string): void {
        if (!!value && value.length > 0) {
            if (this.listAvaliacaoFinalOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listAvaliacaoFinal = this.listAvaliacaoFinalOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listAvaliacaoFinal = this.listAvaliacaoFinalOriginal;
            }
        } else {
            this.listAvaliacaoFinal = this.listAvaliacaoFinalOriginal;
        }

        // this.filteredOptionsAvaFinal = this.formulario.get('avaliacao_final').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listAvaFinal, value))
        //     );
    }

    // createFilterSiloDestino(value?: string): void {
    //     if (!!value && value.length > 0) {
    //         if (this.listSiloDestinoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
    //             this.listSiloDestino = this.listSiloDestinoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
    //         } else {
    //             this.listSiloDestino = this.listSiloDestinoOriginal;
    //         }
    //     } else {
    //         this.listSiloDestino = this.listSiloDestinoOriginal;
    //     }

    //     // this.filteredOptionsSiloDestino = this.formulario.get('destino').valueChanges
    //     //     .pipe(
    //     //         startWith(''),
    //     //         map(value => this.generalService._filterDropDownList(this.listSiloDestino, value))
    //     //     );
    // }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }
}

